import React from 'react';
import NumberFormat from 'react-number-format';
import { v4 as uuidv4 } from 'uuid';

const PhoneInput = props => {
  const { onChange, inputRef, ...rest } = props;

  return (
    <NumberFormat
      {...rest}
      id={uuidv4()}
      getInputRef={inputRef}
      format="+1 (###) ###-####"
      onValueChange={values => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
    />
  );
};

export default PhoneInput;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentSettingsPage/components/ProfileForm/components/PhoneInput/PhoneInput.js